import Index from '@/views/manage/Index'

const manageRouter = {
    path: '/',
    component: Index,
    name: 'layout',
    meta: {title: '首页', icon: 'clipboard'},
    children: [
        {
            path: '/manage/index',
            name: 'manage-index',
            component: Index
        },
        {
            name: 'manage-welcome',
            path: '/manage/welcome',
            components: {innerView: () => import('@/views/Welcome')},
        },
        {
            name: 'manage-user-list',
            path: '/manage/users-list',
            components: {innerView: () => import('@/views/manage/UsersList')},
        },
        {
            name: 'manage-govern-list',
            path: '/manage/govern-list',
            components: {innerView: () => import('@/views/manage/GovernList')},
        },
        {
            name: 'manage-publish-list',
            path: '/manage/publish-list',
            components: {innerView: () => import('@/views/manage/PublishList')},
        },
        {
            name: 'manage-publish-audit',
            path: '/manage/publish-audit',
            components: {innerView: () => import('@/views/manage/PublishAudit')},
        },
        {
            name: 'manage-publish-audit-jyj',
            path: '/manage/publish-audit-jyj',
            components: {innerView: () => import('@/views/manage/PublishAuditJYJ')},
        },
        {
            name: 'manage-publish-view',
            path: '/manage/publish-view',
            components: {innerView: () => import('@/views/manage/PublishView')},
        },
        {
            name: 'manage-settings',
            path: '/manage/settings',
            components: {innerView: () => import('@/views/manage/Settings')},
        },
    ]
}

export {manageRouter}
